import React from "react";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  sub?: string;
  id?: string;
  onDark?: boolean;
};
export function CtaButton({
  label,
  sub,
  id,
  onDark = false
}: CtaButtonProps) {
  return <div className="mx-auto flex w-full max-w-xl flex-col items-center gap-3" id={id} data-id="element-34" data-mp="ck9dxkvkfmbs">
      <a href={CHECKOUT_URL} className="group relative flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-6 py-5 text-center font-display text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#B84300,0_14px_30px_-8px_rgba(255,106,19,0.6)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-[4px] active:shadow-[0_2px_0_0_#B84300,0_8px_20px_-8px_rgba(255,106,19,0.6)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold md:text-xl" data-id="element-35" data-mp="qkafl2jnmxsb">
        <span className="text-balance" data-id="element-36" data-mp="35x5y7jbaqy4l">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-37" data-mp="35yqqt3e1w6zt" />
      </a>
      {sub && <p className={`flex items-center justify-center gap-1.5 text-center text-sm font-medium ${onDark ? "text-brand-soft" : "text-muted"}`} data-id="element-38" data-mp="3ew9fchqwl3gg">
          <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-39" data-mp="3ouywg8az6jvn" />
          <span data-id="element-40" data-mp="3sx3ox3potagp">{sub}</span>
        </p>}
    </div>;
}